@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.main {
  display: flex;
  flex-direction: column;
  @include for-small-desktop-up {
    min-width: 410px;
    margin-top: 100px;
  }

  @include for-phone-only {
    height: 100%;
    justify-content: space-evenly;
    max-height: calc(100% - 75px);
  }
}

.formGap {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.companyLogo {
  margin-top: 20px;
}

.title {
  text-align: center;

  &.withoutSubTitleOrErrors {
    @include for-tablet-landscape-up {
      margin-bottom: 50px;
    }
  }

  @include for-phone-only {
    font-size: 26px;
  }
}

.backButton {
  position: absolute;
  top: 22px;
  left: 22px;
  height: 44px;
  width: 44px;
  background-color: transparent;

  @include for-phone-only {
    top: 1px;
    left: 24px;
  }

  svg {
    fill: var(--neutral-40);
    margin-top: 4px;
    stroke: var(--neutral-90);
  }
}

.testimonialContainer {
  height: 164px;
  @include for-small-desktop-up {
    height: unset;
  }
}

.emailContainer {
  margin-top: 35px;
}

.buttonContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 36px;
  margin-bottom: 36px;

  @include for-phone-only {
    margin-top: 24px;
    margin-bottom: unset;
  }
}

.resetPassword {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.passwordContainer {
  @include lg-sohne;
  font-family: Sohne;
}

.rightArrow {
  margin-left: 5px;
}

.resetPasswordContainer {
  margin-bottom: 8px;
}

.reset {
  @include xs-sohne-medium;
}

.submitButton {
  @include md-sohne;
  margin: 45px auto;
  width: 182px;
  color: white;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 20px */
  letter-spacing: 0.32px;
  &:hover {
    color: var(--neutral-90);
  }

  @include for-tablet-portrait-max {
    width: 100%;
    margin: 32px auto auto;
  }
}
